import { render, staticRenderFns } from "./instagram2-auth.vue?vue&type=template&id=47b45c84&scoped=true&"
import script from "./instagram2-auth.vue?vue&type=script&lang=js&"
export * from "./instagram2-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b45c84",
  null
  
)

export default component.exports